import React from "react";
import * as S from "../css/SearchBar.styles";

const SearchBar = ({
  placeholder,
  value,
  onChange,
  loading = false,
  mode = "search",
  onSend,
}) => {
  const handleKeyPress = (e) => {
    if (mode === "chat" && e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSend?.();
    }
  };

  const SendIcon = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 2L11 13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 2L15 22L11 13L2 9L22 2Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <S.SearchContainer mode={mode}>
      <S.SearchInput
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyPress={handleKeyPress}
        mode={mode}
      />
      {mode === "search" && loading ? (
        <S.LoadingIndicator>Searching...</S.LoadingIndicator>
      ) : (
        <S.SendButton onClick={onSend} disabled={!value.trim()} mode={mode}>
          <SendIcon />
        </S.SendButton>
      )}
    </S.SearchContainer>
  );
};

export default SearchBar;
